import client from '../../utils/api'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const name = 'application-status'

const initialState = {
  instance: null,
  loading: false,
  error: null,
  isVerified: false, 
}

export const checkStatus = createAsyncThunk(
    'application-status/check',
    async ({ applicationId, lastName }, { rejectWithValue }) => {
        try {
            const encodedLastName = encodeURIComponent(lastName)
            const response = await client.get(`/api/application?applicationId=${applicationId}&lastName=${encodedLastName}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message || 'Record not found')
        }
    }
)

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetStatus: (state) => {
      state.instance = null
      state.isVerified = false
      state.error = null
      state.loading = false
    }
  },
  extraReducers(builder) {
    builder
        .addCase(checkStatus.pending, (state) => {
            state.loading = true
            state.error = null
            state.instance = null
            state.isVerified = false
        })
        .addCase(checkStatus.fulfilled, (state, action) => {
          state.loading = false
          state.instance = action.payload
          
          if (action.payload) {
              state.isVerified = true
          }
      })
        .addCase(checkStatus.rejected, (state, action) => {
            state.loading = false
            state.instance = null
            state.isVerified = false
            state.error = action.payload || action.error?.message || 'Record not found'
        })
  },
})

export const { resetStatus } = sessionSlice.actions
export default sessionSlice.reducer
